import { render } from "./PromotionImage.vue?vue&type=template&id=747ab981"
import script from "./PromotionImage.vue?vue&type=script&lang=js"
export * from "./PromotionImage.vue?vue&type=script&lang=js"

import "./PromotionImage.vue?vue&type=style&index=0&id=747ab981&lang=css"
script.render = render

export default script